"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileProcessService = void 0;
class FileProcessService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Returns a signed url to upload a file to the bucket.
     * @returns GetFileSignedUrlResponse
     * @throws ApiError
     */
    getUploadUrl() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/file-process-upload-url',
        });
    }
    /**
     * Receive a pre process command to execute select creators handler.
     * @param requestBody
     * @returns FileProcessResponse
     * @throws ApiError
     */
    createSelectCreatorsPreProcess(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/file-process-select-creators',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Receive a pre process command to execute the feature flag importer handler.
     * @param requestBody
     * @returns FileProcessResponse
     * @throws ApiError
     */
    createFeatureFlagImportPreProcess(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/file-process-ff-import',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Receive a pre process command to execute the channel labels importer handler.
     * @param requestBody
     * @returns FileProcessResponse
     * @throws ApiError
     */
    createChannelLabelsImportPreProcess(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/file-process-channel-labels-import',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Receive a pre process command to execute the agency creator importer handler.
     * @param requestBody
     * @returns FileProcessResponse
     * @throws ApiError
     */
    createAgencyCreatorImportPreProcess(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/file-process-agency-creator-import',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Receive a pre process command to execute the advertiser blocklist handler.
     * @param requestBody
     * @returns FileProcessResponse
     * @throws ApiError
     */
    createAdvertiserBlocklistPreProcess(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/file-process-advertiser-blocklist',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Returns a list of file processes assigned to the reference entity.
     * @param referenceId
     * @param referenceType
     * @param handlerType
     * @returns FileProcessListResponse
     * @throws ApiError
     */
    getFileProcesses(referenceId, referenceType, handlerType) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/file-process',
            query: {
                'referenceId': referenceId,
                'referenceType': referenceType,
                'handlerType': handlerType,
            },
        });
    }
    /**
     * @deprecated
     * Returns a list of file processes assigned to the reference entity. DEPRECATED: use /file-process?referenceId=xxx
     * @param referenceId
     * @returns FileProcessListResponse
     * @throws ApiError
     */
    getFileProcessByReference(referenceId) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/file-process/{referenceId}',
            path: {
                'referenceId': referenceId,
            },
        });
    }
    /**
     * Returns the signed url to access the file on GCS if available.
     * @param id
     * @returns GetFileSignedUrlResponse
     * @throws ApiError
     */
    getFileProcessSignedUrl(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/file-process/{id}/signed-url',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Returns the errors for a file process entry.
     * @param id
     * @returns FileProcessErrorListResponse
     * @throws ApiError
     */
    getFileProcessErrorsById(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/file-process/{id}/errors',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Place the entries pending processing into the queue again.
     * @param id
     * @returns FileProcessResponse
     * @throws ApiError
     */
    replayFileProcessById(id) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/file-process/{id}/replay',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Download the errors when processing a file as csv.
     * @param id
     * @returns any Successful response
     * @throws ApiError
     */
    downloadFileProcessErrorsById(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/file-process/{id}/errors-download',
            path: {
                'id': id,
            },
        });
    }
}
exports.FileProcessService = FileProcessService;
